<ppl-top-bar>
  <ppl-top-navigation></ppl-top-navigation>
</ppl-top-bar>

<ppl-app-container>
  <div class="container">
    <ppl-icon svgIcon="logo-coevera-white"
              class="logo"
              height="56px"
              width="244px"></ppl-icon>


    <div class="section">
      <h2 i18n="@@Applications">Applications</h2>
      <div class="items">
        <ppl-dashboard-item icon="pipeliner-switcher-white"
                            name="CRM"
                            [link]="crmLink"></ppl-dashboard-item>
        <ppl-dashboard-item *ngIf="hasAccessToCustomerPortal$ | async"
                            icon="billing-switcher-white"
                            name="Billing"
                            i18n-name="@@Billing"
                            [link]="customerPortalLink"></ppl-dashboard-item>
        <ppl-dashboard-item *ngIf="hasAccessToBusinessCenter$ | async"
                            icon="business-center-switcher-white"
                            name="Business Center"
                            [link]="businessCenterLink"></ppl-dashboard-item>
        <ppl-dashboard-item *ngIf="hasAccessToPartnerPortal$ | async"
                            icon="partners-switcher-white"
                            name="Partner Portal"
                            [link]="partnerPortalLink"></ppl-dashboard-item>
      </div>
    </div>
    <div class="section">
      <h2 i18n="@@Pipeliner_Universe">Pipeliner Universe</h2>
      <div class="items">
        <ppl-dashboard-item icon="goahead-switcher-white"
                            name="Go Ahead!"
                            i18n-name="@@GoAhead"
                            target="_blank"
                            link="https://go-ahead.global"></ppl-dashboard-item>
        <ppl-dashboard-item icon="salespop-switcher-white"
                            name="Sales POP!"
                            i18n-name="@@SalesPOP"
                            target="_blank"
                            link="https://salespop.net"></ppl-dashboard-item>

      </div>
    </div>
  </div>
</ppl-app-container>
